<!--
 *@Author: 作者名 lx
 *@Date: 2026-01-10 10:41:51
 *@Description: 公共页面组件底部，页面
-->

<template>
    <footer>
        <p class="copyright">&copy; {{ new Date().getFullYear() }} Lixiang · Powered by Cloudflare Pages</p>
    </footer>
</template>

<style scoped>
footer {
    text-align: center;
    padding: 20px 0;
}

.copyright {
    margin: 0;
    color: #666;
    font-size: 14px;
}
</style>

